import React from 'react';


export const createFilters = <TItem, TFilters extends Record<string, unknown>>(params: {
  initialValues: TFilters;
  matchItem?: (item: TItem, filters: TFilters) => boolean;
  calcFiltersCount?: (obj: TFilters) => number;
}) => {
  type Key = keyof TFilters;
  const Context = React.createContext<{
    filters: TFilters;
    filtersCount: number;
    setFilterValue: <K extends Key>(key: K, value: TFilters[K]) => void;
    setFilterValues: (value: Partial<TFilters>) => void;
    matchItem: (item: TItem) => boolean;
  } | null>(null);

  return {
    useContext: () => {
      const context = React.useContext(Context);

      if (!context) {
        throw new Error('filters useContext must be used within a Provider');
      }

      return context;
    },
    Provider: ({ children }: { children: React.ReactNode }) => {
      const [ state, setState ] = React.useState(params.initialValues);
      const filtersCount = React.useMemo(() => {
        // return Object.keys(state).reduce((prev, curr) => prev + (state[curr] === null ? 1 : 0), 0);
        return params.calcFiltersCount ? params.calcFiltersCount(state) : 0;
      }, [ state ]);

      return (
        <Context.Provider
          value={{
            filters: state,
            filtersCount,
            setFilterValue: <K extends Key>(key: K, value: TFilters[K]) => {
              setState(prev => ({ ...prev, [key]: value }));
            },
            setFilterValues: (values: Partial<TFilters>) => {
              setState(prev => ({ ...prev, ...values }));
            },
            matchItem: item => params.matchItem?.(item, state) ?? false,
          }}
          children={children}
        />
      );
    },
  };
};
